import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Logo = ({ isScrolled = false, className = '' }) => {
  const { language } = useLanguage();

  return (
    <a 
      href="#page-top" 
      className={`flex items-center group transition-all duration-300 ${className}`}
      aria-label="Haros Event Venue Home"
    >
      <div className="relative">
        {/* Logo Image with Elegant Frame */}
        <div className="relative overflow-hidden rounded-lg shadow-embossed group-hover:shadow-embossed-lg transition-all duration-300 bg-rustic-cream/80 backdrop-blur-sm">
          {/* Decorative frame border with gradient */}
          <div className="absolute inset-0 border-2 border-deep-brown/20 rounded-lg group-hover:border-terracotta/40 transition-all duration-300" 
               style={{
                 background: 'linear-gradient(135deg, rgba(92,74,55,0.05) 0%, transparent 50%, rgba(201,125,96,0.05) 100%)'
               }}
          />
          
          {/* Inner shadow for depth */}
          <div className="absolute inset-0 rounded-lg shadow-inner opacity-10" />
          
          {/* Image container with elegant padding - optimized for new logo design */}
          <div className="relative bg-rustic-cream p-2 sm:p-2.5 md:p-3 rounded-md">
            <img 
              src="/img/IMG_20221211_204554 2.jpg" 
              alt="Haros Event Center - Elegant Event Venue in Alvarado, Texas" 
              className={`h-16 sm:h-18 md:h-20 lg:h-24 w-auto object-contain transition-all duration-300 group-hover:scale-[1.02] ${
                isScrolled ? 'h-14 sm:h-16 md:h-18' : ''
              }`}
              loading="eager"
              style={{
                filter: 'contrast(1.05) brightness(0.98)',
              }}
            />
          </div>
          
          {/* Decorative corner accents - subtle vintage style */}
          <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-deep-brown/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-tl-lg" />
          <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-deep-brown/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-tr-lg" />
          <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-deep-brown/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-bl-lg" />
          <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-deep-brown/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-br-lg" />
          
          {/* Subtle texture overlay */}
          <div className="absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-300 pointer-events-none"
               style={{
                 backgroundImage: "url('data:image/svg+xml,%3Csvg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\"%3E%3Cg fill=\"none\" fill-rule=\"evenodd\"%3E%3Cg fill=\"%235C4A37\" fill-opacity=\"0.08\"%3E%3Cpath d=\"M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
               }}
          />
        </div>
      </div>
      
      {/* Subtle warm glow effect on hover */}
      <div className="absolute -inset-1 bg-golden-glow opacity-0 group-hover:opacity-20 transition-opacity duration-300 pointer-events-none rounded-lg blur-sm -z-10" />
    </a>
  );
};

export default Logo;
